import React from 'react'
import ListCandidateView from './components/view/list-candidate-view'
import styles from './candidate.module.css'

const Candidate = () => (
    <div className={styles.page}>
        <ListCandidateView />
    </div>
)

export default Candidate
